import React, { useState } from 'react';
import Swal from 'sweetalert2';

function LoanExportPage({ currentUser }) {
  const [status, setStatus] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  const handleExport = async () => {
    if (!status && !dateFrom && !dateTo) {
      Swal.fire('Error', 'Please select at least one filter before exporting.', 'error');
      return;
    }

    try {
      const query = new URLSearchParams({
        status,
        date_from: dateFrom,
        date_to: dateTo
      });

      const res = await fetch(`https://api.stitchtechsolutions.com/api/export_loans_csv.php?${query.toString()}`);
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `LoanExport_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      Swal.fire('Error', 'Failed to generate export.', 'error');
    }
  };

  if (currentUser?.role !== 'superadmin') return <p>Access denied.</p>;

  return (
    <div>
      <h2>Export Loans to CSV</h2>
      <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
        <div>
          <label>Status:</label><br />
          <select value={status} onChange={e => setStatus(e.target.value)}>
            <option value="">All</option>
            <option>Pending</option>
            <option>Processing</option>
            <option>Reprocessing</option>
            <option>For Final Checking</option>
            <option>Not Yet Started</option>
            <option>Hold</option>
            <option>Disapproved</option>
            <option>Disbursed</option>
            <option>Cancelled</option>
          </select>
        </div>

        <div>
          <label>Approval Date From:</label><br />
          <input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} />
        </div>

        <div>
          <label>Approval Date To:</label><br />
          <input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} />
        </div>
      </div>

      <button style={{ marginTop: '1rem' }} onClick={handleExport}>
        Export to CSV
      </button>
    </div>
  );
}

export default LoanExportPage;
